import { get, post } from "@/vue/api/api";

export const porting = {
  state: {
    portOrdersResults: [],
    // DMS countries api response on 01/20/2022
    countries: [
      "AO",
      "AR",
      "AS",
      "AT",
      "AU",
      "BB",
      "BE",
      "BG",
      "BR",
      "BS",
      "CA",
      "CH",
      "CL",
      "CN",
      "CO",
      "DE",
      "DK",
      "ES",
      "FI",
      "FR",
      "GB",
      "GR",
      "HK",
      "HU",
      "ID",
      "IE",
      "IL",
      "IN",
      "IT",
      "JP",
      "LU",
      "MX",
      "NL",
      "NZ",
      "PE",
      "PH",
      "PL",
      "PR",
      "PT",
      "RO",
      "RU",
      "SE",
      "SG",
      "TW",
      "UG",
      "US",
      "VI",
      "ZA",
    ],
  },
  getters: {
    getPortOrdersResults: (state) => {
      return state.portOrdersResults;
    },
    getDmsCountries: (state) => {
      return state.countries;
    },
  },
  mutations: {
    SET_PORT_ORDERS_RESULTS: (state, payload) => {
      state.portOrdersResults = payload;
    },
    SET_DMS_COUNTRIES: (state, payload) => {
      state.countries = payload;
    },
  },
  actions: {
    //Bulk prevalidation
    sendPortOrders: ({ commit, dispatch, rootGetters }, payload) => {
      // /v1/bps/customer/{customerId}/execute
      post(
        "/v1/customers/" + rootGetters.getCustomer.cid + "/porting",
        payload.data
      )
        .then((response) => {
          console.log("sendPortOrders response");
          console.log(response);
          console.log(response.data);

          commit("SET_PORT_ORDERS_RESULTS", response);
          payload.success(response.message);
          //audit
          dispatch("sendAudit", {
            eventType: "CREATE",
            objectType: "Port Orders",
            details: payload.data,
          });
        })
        .catch((error) => {
          console.log("sendPortOrders error");
          console.log(error);
          payload.error(error);
        });
    },
    async fetchDmsCountries({ commit }) {
      const countries = await get("/v1/dms/countries");
      commit("SET_DMS_COUNTRIES", countries);
      return countries;
    },
  },
};
